export const EVENTS = {
  DIALOG: {
    OPENED: 'dialog.opened',
    CLOSED: 'dialog.closed',
    BACK_ACTION_CLOSE_REQUIRED: 'dialog.back_action_close_required',
    PROMPT_REQUESTED: 'dialog.PROMPT_REQUESTED',
  }
};
